import { matchPath } from 'react-router';
import { RoleHelper } from '@shoflo/polymer/helpers/RoleHelper/RoleHelper';
import Paths from 'AppPaths';

export function getPathname(getState) {
  const { router } = getState();

  if (!router) return '';

  return router.location.pathname;
}

export function getUngreedyEventRouteMatch(getState) {
  const pathName = getPathname(getState);

  let match = matchPath(pathName, {
    path: Paths.EventDashFolder
  });

  if (!match) {
    match = matchPath(pathName, {
      path: Paths.EventDashTrash
    });
  }

  if (!match) {
    match = matchPath(pathName, {
      path: Paths.EventDashSaved
    });
  }

  if (!match) {
    match = matchPath(pathName, {
      path: Paths.EventDash
    });
  }

  return match;
}

export function getTeamRouteMatch(getState) {
  const pathName = getPathname(getState);

  return matchPath(pathName, {
    path: Paths.TeamDash
  });
}

export function getEventRouteMatch(getState) {
  const pathName = getPathname(getState);

  return matchPath(pathName, {
    path: Paths.EventDash
  });
}

export const hasEventRouteState = getState => {
  const match = getUngreedyEventRouteMatch(getState);

  return match ? true : false;
};

/**
 * Unsure if this will be necessary
 */

// export const getCurrentFolderId = (getState) => {

//   let match = matchPath(getPathname(getState), {
//     path: Paths.EventDashFolder
//   });

//   if (match && match.params) return match.params.folderId;
//   return undefined;

// }

export const getCurrentTeamId = getState => {
  const teamRouteMatch = getTeamRouteMatch(getState);
  if (!teamRouteMatch) return null;
  return teamRouteMatch.params.teamId;
};

export const getCurrentEventId = getState => {
  const eventRouteMatch = getEventRouteMatch(getState);
  if (!eventRouteMatch) return null;
  return eventRouteMatch.params.eventId;
};

export const getCurrentUserId = getState => {
  const { user } = getState();
  return user._id;
};

export const isAdminForTeam = getState => {
  const { user } = getState();
  const teamId = getCurrentTeamId(getState);
  return RoleHelper.hasTeamAdminRole(user, teamId);
};

export const isEventAdmin = getState => {
  const { user } = getState();
  const teamId = getCurrentTeamId(getState);
  const eventId = getCurrentEventId(getState);
  return RoleHelper.hasEventAdminRole(user, teamId, eventId);
};

// export const getCurrentEventId = (getState) => {
//   return getUngreedyEventRouteMatch(getState).params.eventId;
// }

/**
 * Helper for executing with current params..
 *
 * @param {*} cb
 */
export const withCurrentParams = cb => {
  return (dispatch, getState) => {
    if (hasEventRouteState(getState)) {
      const match = getUngreedyEventRouteMatch(getState);

      cb(dispatch, match.params, getState);
    } else {
      throw new Error(
        'The current route does not have the necessary parameters'
      );
    }
  };
};

/**
 * The UserDash doesnt have any params in the url
 * @param {*} eventIdOrObj
 * @param {*} getState
 * @returns
 */
export const getEventTeam = (eventIdOrObj, getState) => {
  const { userEvents } = getState();

  const userEventObject =
    typeof eventIdOrObj === 'string' &&
    userEvents.filter(event => event._id === eventIdOrObj)[0];

  const team = userEventObject?.team || eventIdOrObj.team;

  return typeof team === 'string' ? team : team._id;
};
